import { computed, readonly, nextTick } from 'vue';
import { useStore } from 'vuex';
import { GET_SLIDEOUT_STACK } from '../../types/getters';
import { SET_SLIDEOUT, BACK_SLIDEOUT } from '../../types/setters';

/**
 *
 * @param {*} store
 * @returns {import('vue').ComputedRef<Slideout[]>}
 */
function getSlideoutStack(store) {
  return computed(() => store.getters[`slideout/${GET_SLIDEOUT_STACK}`]);
}

/**
 * * @returns {{
 * slideout: Readonly<import('vue').Ref<Slideout>>,
 * isSlideoutAvailable: Readonly<import('vue').Ref<boolean>>,
 * showSlideout: (slideout: Slideout) => void,
 * addSlideout: (slideout: Slideout) => void,
 * backSlideout: (slideout: Slideout) => void,
 * }} slideout
 */
export function useSlideout() {
  const store = useStore();
  // TODO: try to avoid using vuex store
  const slideoutStack = getSlideoutStack(store);

  const slideout = computed(() => slideoutStack.value[0]);
  const isSlideoutAvailable = computed(() => !!slideout.value);

  /**
   * @param {Slideout} slideoutObj
   * @returns {void}
   */
  function showSlideout(slideoutObj) {
    store.commit(`slideout/${SET_SLIDEOUT}`, slideoutObj);

    nextTick(() => { // wait for slideout to be available
      store.commit('slideoutStore/TOGGLE', slideoutObj.id);
    });
  }

  /**
   * @param {Slideout} slideoutObj
   * @returns {void}
   */
  function addSlideout(slideoutObj) {
    store.commit(`slideout/${SET_SLIDEOUT}`, slideoutObj);
  }

  /**
   * @param {Slideout} slideoutObj
   * @returns {void}
   */
  function backSlideout(slideoutObj) {
    store.commit(`slideout/${BACK_SLIDEOUT}`, slideoutObj);
  }

  return {
    slideout: readonly(slideout),
    isSlideoutAvailable: readonly(isSlideoutAvailable),
    showSlideout,
    addSlideout,
    backSlideout,
  };
}

export default useSlideout;
